var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.90707 3.9687L5.07372 4.61916C3.80984 5.60568 3.1779 6.09895 2.83895 6.79445C2.5 7.48994 2.5 8.29338 2.5 9.90025V11.6429C2.5 14.7968 2.5 16.3738 3.47631 17.3536C4.45262 18.3333 6.02397 18.3333 9.16667 18.3333H10.8333C13.976 18.3333 15.5474 18.3333 16.5237 17.3536C17.5 16.3738 17.5 14.7968 17.5 11.6429V9.90025C17.5 8.29338 17.5 7.48994 17.1611 6.79445C16.8221 6.09895 16.1902 5.60568 14.9263 4.61916L14.0929 3.9687C12.1268 2.43401 11.1437 1.66667 10 1.66667C8.85633 1.66667 7.87322 2.43401 5.90707 3.9687Z",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.86365 18.9484L6.86565 15.2614C6.86611 14.4041 6.86634 13.9755 7.0253 13.6374C7.23765 13.1857 7.64508 12.8268 8.15781 12.6399C8.5417 12.5 9.02815 12.5 10.001 12.5C10.9743 12.5 11.4609 12.5 11.8449 12.64C12.3578 12.827 12.7652 13.186 12.9774 13.638C13.1364 13.9763 13.1364 14.4051 13.1364 15.2627V18.9484",
    stroke: "black",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.9a658f3567e81a116401f2d88180a714.svg";
export { ForwardRef as ReactComponent };